const MENU = {
  dashboard: 'Dashboard',
  product_catalog: 'Products and Systems',
  system_applications: 'Application Areas',
  cart: 'Cart',
  scanner: 'QR Scanner',
  mixer: 'Mixer',
  qcvmixer: 'QCV Mixer',
  elasticmixer: 'Flakes Mixer',
};

export default MENU;
